/**
 * @fileoverview GET handler for the "/apps/business/usage" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsBusinessUsage } from "./constants";
import type { AppsBusinessUsageResult } from "./types";
import { isAppsBusinessUsageResult } from "./validators";

export const getAppsBusinessUsage = reactQueryFetcherAdapter(
  appsBusinessUsage,
  (signal: AbortSignal): Promise<AppsBusinessUsageResult> => {
    return fetch("/apps/business/usage", "GET", {}, { signal });
  },
  isAppsBusinessUsageResult
);
